import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const LiftHeight = ({ liftHeight }: SpecProps<"lift_height">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (liftHeight === undefined) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.liftHeight",
    message: "Lift height",
    comment: "Label for 'Lift height'",
  });

  const liftHeightValue = i18n.t({
    id: "itemPageLayout.common.meters.postfix",
    message: "{meters} m",
    comment: "Meters postfix in ad specification",
    values: {
      meters: formatNumber(liftHeight, locale),
    },
  });

  return <FieldValuePair field={field} value={liftHeightValue} />;
};
